import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { path: 'employee', loadChildren: () => import('../../employee/employee.module').then(m => m.EmployeeModule) }, 
  {
    path: 'materialmanagement',
    loadChildren: () => import('../../material-management/material-management.module').then(m => m.MaterialManagementModule)
  },
  {
    path: 'frontoffice',
    loadChildren: () => import('../../frontoffice/frontoffice.module').then(m => m.FrontOfficeModule)
  },
  
  {
  path: 'baseframework',
  loadChildren: () => import('../../baseframework/baseframework.module').then(m => m.BaseFrameworkModule)
  },
  {
  path: 'commonpagecomponent',
  loadChildren: () => import('../../common-page-component/common-page-component.module').then(m => m.CommonPageComponentModule)
  }
];
